import { useEffect, useRef, useState } from "react";

/** Animated count-up that starts when scrolled into view. Accepts "32,253" style values. */
const CountUp = ({
  value,
  duration = 2000,
  className = "",
}: {
  value: string;
  duration?: number;
  className?: string;
}) => {
  const target = parseInt(value.replace(/[^0-9]/g, ""), 10) || 0;
  const [display, setDisplay] = useState("0");
  const ref = useRef<HTMLSpanElement>(null);
  const started = useRef(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !started.current) {
          started.current = true;
          const start = performance.now();
          const tick = (now: number) => {
            const p = Math.min((now - start) / duration, 1);
            const eased = 1 - Math.pow(1 - p, 3); // ease-out cubic
            setDisplay(Math.round(target * eased).toLocaleString("en-US"));
            if (p < 1) requestAnimationFrame(tick);
          };
          requestAnimationFrame(tick);
          obs.disconnect();
        }
      },
      { threshold: 0.4 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, [target, duration]);

  return (
    <span ref={ref} className={className}>
      {display}
    </span>
  );
};

export default CountUp;
